<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-link`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_2a304a1348__clip0_1:471)"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.333 20.284c3.475-4.292 2.813-10.59-1.479-14.065-4.292-3.476-10.589-2.814-14.064 1.478l-5.664 6.995c-3.476 4.292-2.814 10.589 1.478 14.064a10.006 10.006 0 002.433 1.456l2.704-3.338a6 6 0 01-3.506-9.665l5.663-6.994a6 6 0 019.326 7.551l-3.597 4.442a6.971 6.971 0 011.116 3.123l.173 1.643 5.417-6.69zm-11.848-1.225a10.004 10.004 0 00-2.433-1.456l-2.704 3.339a6 6 0 013.506 9.665L20.19 37.6a6 6 0 01-9.325-7.552l3.597-4.442a6.971 6.971 0 01-1.116-3.122l-.174-1.644-5.416 6.69C4.28 31.823 4.942 38.12 9.234 41.595c4.292 3.476 10.59 2.814 14.065-1.478l5.664-6.995c3.475-4.291 2.814-10.588-1.478-14.064z"/></g><defs><clipPath id="svg_2a304a1348__clip0_1:471"><path d="M0 0h48v48H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLink',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
